import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import ListItemComponent, { IStateListItem } from 'components/Abstract/ListItem';
import Alert from 'components/Shared/Alert';
import { IOption } from 'components/Shared/DropdownMenu';
import Snackbar from 'components/Shared/Snackbar';
import { cnpj } from 'formatters/masks';
import { IVenture } from 'interfaces/venture';
import DeleteIcon from 'mdi-react/DeleteIcon';
import EditIcon from 'mdi-react/EditIcon';
import * as React from 'react';
import rxjsOperators from 'rxjs-operators';
import ventureService from 'services/venture';

interface IState extends IStateListItem {
  deleted?: boolean;
}

interface IProps {
  venture: IVenture;
  onEdit: (venture: IVenture) => void;
  onDeleteComplete: () => void;
}

export default class ListItem extends ListItemComponent<IProps, IState> {
  private readonly options: IOption[];

  constructor(props: IProps) {
    super(props);
    this.options = [{
      text: 'Editar',
      icon: EditIcon,
      handler: this.handleEdit
    }, {
      text: 'Excluir',
      icon: DeleteIcon,
      handler: this.handleDelete
    }];
  }

  handleEdit = () => {
    const { venture, onEdit } = this.props;
    onEdit(venture);
  }

  handleDelete = async () => {
    const { venture, onDeleteComplete } = this.props;
    const title = `Tem certeza que deseja excluir o empreendimento "${venture.name}"?`;
    const ok = await Alert.confirm({ title, mode: 'delete' });
    if (!ok) return;

    this.setState({ loading: true });

    ventureService.delete(venture.id).pipe(
      rxjsOperators.logError(),
      rxjsOperators.bindComponent(this)
    ).subscribe(() => {
      Snackbar.show(`${venture.name} foi removido`);
      this.setState({ loading: false, deleted: true });
      onDeleteComplete();
    }, error => {
      this.setState({ loading: false, error });
    });
  }

  render(): JSX.Element {
    const { deleted } = this.state;
    const { venture } = this.props;

    if (deleted) {
      return null;
    }

    return (
      <TableRow>
        <TableCell>{venture.name}</TableCell>
        <TableCell>{venture.cnpj ? cnpj.apply(venture.cnpj) : '-'}</TableCell>
        <TableCell>{venture.address}</TableCell>
        <TableCell>{venture.uf}</TableCell>
        <TableCell>{venture.city}</TableCell>
        <TableCell>
          {this.renderSideMenu(this.options)}
        </TableCell>
      </TableRow>
    );
  }
}